/**
 * Public master-data API client for the Book Shipment form.
 *
 * Fetches org-scoped master data (managed in the admin web app's Master
 * modules) from the no-auth public endpoints:
 *   GET {BASE}/api/v1/enquiries/public/:orgSlug/countries
 *   GET {BASE}/api/v1/enquiries/public/:orgSlug/cities?countryId=…
 *   GET {BASE}/api/v1/enquiries/public/:orgSlug/commodity-types
 *   GET {BASE}/api/v1/enquiries/public/:orgSlug/payment-types
 */

const BASE = process.env.REACT_APP_API_URL ?? 'http://localhost:4000';
const ORG_SLUG = process.env.REACT_APP_ORG_SLUG ?? 'sahari-cargo';

export type MasterOption = { id: string; name: string };

async function getList(path: string): Promise<MasterOption[]> {
  try {
    const res = await fetch(
      `${BASE}/api/v1/enquiries/public/${ORG_SLUG}/${path}`,
    );
    if (!res.ok) return [];
    const json = await res.json();
    const data = json?.data ?? [];
    return Array.isArray(data) ? (data as MasterOption[]) : [];
  } catch {
    return [];
  }
}

export const fetchCountries = () => getList('countries');

export const fetchCities = (countryId?: string) =>
  getList(
    countryId ? `cities?countryId=${encodeURIComponent(countryId)}` : 'cities',
  );

export const fetchCommodityTypes = () => getList('commodity-types');

export const fetchPaymentTypes = () => getList('payment-types');
